import React from 'react'
import { Modal, Button, Container, Row, Col } from "react-bootstrap"
import InnerHTML from 'dangerously-set-html-content'
import Icon from "../../assets/ArrowWithStem.svg"
import RtapPhoneNumber from "../RtapPhoneNumber/RtapPhoneNumber"

// Load up a enquiry form modal window.
// Load a CRM form served by the WDX CRM system (third party).
function EnquiryModal(props) {

  let modalTitle = "Make an enquiry"
  if(props.emailtoname) modalTitle += " to "+props.emailtoname
  //if(props.emailto) modalTitle += " ("+props.emailto+")"

  /* Remove context from messaging
  if(props.productname) {
    if(props.productname !== "Request a callback") modalTitle += " about "+props.productname
  }
  if(props.branchname) modalTitle += " to the "+props.branchname+" office"
  */

  // Set defaults here.
  let modalintro = "If you have any questions or would like to find out more about our services, please submit a contact request and our team will be in touch as soon as possible."
  let modalcallintro = "...alternatively call us on"

  let modalCallLink = "020 7600 1660"



  // Prod form:
  let formCode = `<script type="text/javascript">var loc = "https://analytics-eu.clickdimensions.com/jmfinncom-a5msl/pages/";</script>
<script type="text/javascript" src="https://cdn-eu.clickdimensions.com/web/v10/CDWidget.js"></script>
<div pageID="r5ujl0ugeeui0iva9f96xw"></div>`

  // New replacement form (testing with CRM team):
//   let formCode = `<script type="text/javascript">var loc = "https://analytics-eu.clickdimensions.com/jmfinncom-aytlt/pages/";</script>
// <script type="text/javascript" src="https://cdn-eu.clickdimensions.com/web/v10/CDWidget.js"></script>
// <div pageID="r5ujl0ugeeui0iva9f96xw"></div>`


  // Override defaults if props dictate.
  if(props.modalintro) modalintro = props.modalintro
  if(props.modalcallintro) modalcallintro = props.modalcallintro
  if(props.modalcallnumber) {
    modalCallLink = props.modalcallnumber
  }

  // After the form widget launches test for the injected code then apply defaults to the hidden inputs etc.
  function PrepopulateForm(props) {

    // Sometimes the CRM form takes a long time to load.
    // Loop a test for the form as we inject some values into hidden fields.
    setTimeout(function checkForForm() {
      let crmForm = document.getElementById("clickdimensionsForm");
      if(crmForm){
        if(props.show === true){
          const urlId = "cd_domainalias",
          personEmailId = "cd_visitoremail",
          branchId = "officeQuestion",
          serviceId = "serviceQuestion"

          // Gather all hidden fields and look for specific placeholder values
          // - these are set within the CRM for us to use as targets
          let inputsHidden = document.querySelectorAll('input[type=hidden]')
          let allHidden = inputsHidden.length
          for(var i = 0; i < allHidden; i++) {
            let inputsHiddenValue = inputsHidden[i].value

            if(inputsHiddenValue == "placeholder email"){
              if(props.emailto) {
                inputsHidden[i].value = props.emailto
              }
              else {
                inputsHidden[i].value = ''
              }
            }
            else if(inputsHiddenValue == "placeholder url"){
              inputsHidden[i].value = window.location.href
            }
          }

          // Currently unavailble, but desired for the future.
          // if(props.productname) {}
          // if(props.branchname) {}
          clearTimeout(checkForForm);
        }
      }
      else {
        // Loop - no form found.
        setTimeout(checkForForm, 1000);
      }
    }, 1000);

    return("")

  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeLabel="Close" closeButton>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={12} lg={6}>
              <p className="hr hr--top modal__title">{modalTitle}</p>
              <p className="modal__inner-content">{modalintro}</p>
              <p><span className="modal__contact">{modalcallintro}
              <RtapPhoneNumber number={modalCallLink} additionalclasses="modal__contact--link" />
              </span></p>
            </Col>
            <Col className="modal__form" md={12} lg={6}>
              <InnerHTML html={formCode} />
            </Col>
            <PrepopulateForm {...props}/>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}



function ModalEnquire(props) {
  const [modalShow, setModalShow] = React.useState(false);

  let button = ""
  if(props.buttontext) button = (
    <Button className={`${props.classes ? props.classes : ''} modal-button`} variant="secondary" onClick={() => setModalShow(true)}>
      {props.buttontext}
      {props.hasIcon ? <Icon width="24" /> : null}
    </Button>
  )

  return (
    <>
      {button}
      <EnquiryModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        emailto={props.emailto}
        emailtoname={props.emailtoname}
        productname={props.productname}
        branchname={props.branchname}
        modalintro={props.modalintro}
        modalcallintro={props.modalcallintro}
        modalcallnumber={props.modalcallnumber}
      />
    </>
  )
}

export default ModalEnquire
